// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ntjS","itemTitle":"ClientEmergencyInfo_itemTitle__3E6Mb","itemText":"ClientEmergencyInfo_itemText__WCFQM"};